// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

// Shown when a signed-in user lacks operator access to the console, and also
// reused by pages when they receive a 403 from the API.

import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ShieldOff } from 'lucide-react'
import { useAuth } from '@/context/auth-context'
import { Button } from '@/components/ui/button'

export default function AccessDenied() {
  const { t } = useTranslation()
  const { signOutUser } = useAuth()
  const navigate = useNavigate()

  async function handleSignOut() {
    try {
      await signOutUser()
    } finally {
      navigate('/login', { replace: true })
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-sm w-full rounded-2xl border border-border bg-card shadow-lg p-8 flex flex-col items-center gap-6 text-center">
        <div className="h-14 w-14 rounded-full bg-destructive/10 flex items-center justify-center">
          <ShieldOff className="h-7 w-7 text-destructive" />
        </div>

        <div className="space-y-2">
          <h1 className="text-xl font-semibold text-foreground">
            {t('accessDenied.title')}
          </h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {t('accessDenied.body')}
          </p>
        </div>

        <Button
          variant="destructive-outline"
          size="default"
          onClick={() => void handleSignOut()}
          className="w-full"
        >
          {t('accessDenied.signOut')}
        </Button>
      </div>
    </div>
  )
}
